import { useFormContext } from "react-hook-form";
import {
    TextField,
    Typography,
    Box,
    Stack,
    InputAdornment,
    IconButton,
    Popover,
} from "@mui/material";
import { useTranslatedMessages } from "@/multiLanguage/i18n";
import HelpIcon from "@mui/icons-material/Help";
import { theme } from "@/theme";
import { useEffect, useState } from "react";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";

function LipoproteinData() {
    const {
        setValue,
        watch,
        register,
        trigger,
        formState: { errors },
    } = useFormContext();
    const lang = useTranslatedMessages();
    const [infoTextIsOpen, setInfoTextIsOpen] = useState<boolean>(false);
    const [infoText, setInfoText] = useState<string>("");
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const lipoproteinEndTextSelected = watch("lipoproteinUom");

    useEffect(() => {
        if (!lipoproteinEndTextSelected) {
            setValue("lipoproteinUom", "nmol/L");
        }
    }, [lipoproteinEndTextSelected, setValue]);

    const handleClick = (endText: string[]) => {
        const index = endText.indexOf(lipoproteinEndTextSelected);
        if (index === -1 || index + 1 === endText.length) {
            setValue("lipoproteinUom", endText[0]);
        } else {
            setValue("lipoproteinUom", endText[index + 1]);
        }
        trigger("lipoproteinValue");
    };
    return (
        <Stack gap={1}>
            <Box height={65}>
                <TextField
                    {...register("lipoproteinValue", {
                        valueAsNumber: true,
                        validate: (value) => {
                            if (value === undefined || value === null || Number.isNaN(value)) {
                                return true;
                            }
                            if (value < 0) {
                                return lang.scales.lipoproteinComponent.lipoprotein.errorText;
                            }
                            return true;
                        },
                    })}
                    label={<>{lang.scales.lipoproteinComponent.lipoprotein.label}</>}
                    type="number"
                    inputProps={{
                        step: ".01",
                        onWheel: (event: any) => {
                            event.target.blur();
                        },
                    }}
                    fullWidth
                    error={!!errors.lipoproteinValue}
                    helperText={
                        errors.lipoproteinValue ? String(errors.lipoproteinValue?.message) : " "
                    }
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Stack
                                    justifyContent={"end"}
                                    flexDirection={"row"}
                                    sx={{
                                        textAlign: "center",
                                        width: ["8rem"],
                                        color: theme.palette.secondary.dark,
                                        cursor: "pointer",
                                        padding: "5px",
                                    }}
                                >
                                    {lipoproteinEndTextSelected}
                                    <ChangeCircleIcon
                                        onClick={() => handleClick(["nmol/L", "mg/dL"])}
                                    ></ChangeCircleIcon>
                                </Stack>
                                <IconButton
                                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                        setAnchorEl(event.currentTarget);
                                        setInfoText(
                                            lang.scales.lipoproteinComponent.lipoprotein.infoText
                                        );
                                        setInfoTextIsOpen(true);
                                    }}
                                    edge="end"
                                >
                                    {<HelpIcon sx={{ color: theme.palette.secondary.light }} />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    FormHelperTextProps={{
                        style: {
                            fontSize: '0.65rem',
                        },
                    }}
                />
            </Box>

            <Popover
                open={infoTextIsOpen}
                anchorEl={anchorEl}
                onClose={() => {
                    setInfoTextIsOpen(false);
                }}
                disableScrollLock
                transformOrigin={{
                    horizontal: "left",
                    vertical: "bottom",
                }}
            >
                <Typography sx={{ p: 2 }}>{infoText}</Typography>
            </Popover>
        </Stack>
    );
}

export default LipoproteinData;
